<template>
  <div class="rich-editor-wrapper">
    <div ref="editor" style="line-height: 1.4"></div>
    <div class="word-counter" :class="{ 'is-error': wordLimit < currentPureValue.length }" v-if="wordLimit">
      <span>{{ currentTextCount }}</span
      >/<span>{{ wordLimit }}</span>
    </div>
  </div>
</template>

<script>
// 修改了wagEditor中的代码 wangEditor/issues/1263
import E from './wangEditor'
import { isWordDocument, filterPasteWord } from '@/components/common/RichText/helper'
// import emitter from 'element-ui/lib/mixins/emitter'
import { debounce } from '@/utils'

export default {
  name: 'RichText',
  // mixins: [emitter],
  props: {
    value: {
      type: String,
      default: ''
    },
    wordLimit: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentValue: '',
      currentPureValue: '', // 仅包含文本，不包含标签
      editorInstance: null,
      currentTextCount: 0,
    }
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (val !== this.currentValue) {
          this.currentValue = val
          if (this.editorInstance) {
            this.editorInstance.txt.html(val)
          }
        }
      },
      immediate: true
    },
    currentValue(val, oldVal) {
      setTimeout(() => {
        let pureText = (this.currentPureValue = this.editorInstance.txt.text().replace(/&nbsp;/g, ' '))
        this.$emit('pure-update', pureText)
        this.dispatch('ElFormItem', 'el.form.change', [pureText])
      }, 20)
      if (this.wordLimit) {
        debounce(this.calcTextNum, 50)()
      }
    },
    currentTextCount(val,oldVal){
      if (this.wordLimit){
        this.$emit('rickInput',this.currentTextCount)
      }
    }
  },
  mounted() {
    this.initEditor()
  },
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    initEditor() {
      this.editorInstance = new E(this.$refs.editor)
      this.editorInstance.customConfig.onchange = html => {
        this.currentValue = html
        this.$emit('input', html)
      }
      this.editorInstance.customConfig.menus = ['head',
        'bold',
        'fontSize',
        'fontName',
        'italic',
        'underline',
        'strikeThrough',
        'indent',
        'lineHeight',
        'foreColor',
        'backColor',
        'link',
        'list',
        'todo',
        'justify',
        'quote',
        'emoticon',
        'table',
        'code',
        'splitLine',
        'undo',
        'redo',]
      this.editorInstance.customConfig.zIndex = 1999
      this.editorInstance.customConfig.pasteTextHandle = function(content) {
        // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
        return isWordDocument(content) ? filterPasteWord(content) : content
      }
      this.currentValue = this.value
      this.editorInstance.create()
      if (this.wordLimit) {
        this.editorInstance.$textContainerElem[0].style.paddingBottom = '17px'
      }
    },
    setPosition(position) {
      // 定位光标位置
      const el = this.editorInstance.$textElem[0]
      let s = window.getSelection()
      let r = document.createRange()
      r.setStart(el, position)
      r.setEnd(el, position)
      s.removeAllRanges()
      s.addRange(r)
    },
    calcTextNum() {
      this.currentTextCount = this.currentPureValue.length
    }
  }
}
</script>

<style lang="less" scoped>
.rich-editor-wrapper {
  position: relative;
  .word-counter {
    position: absolute;
    bottom: 5px;
    right: 10px;
    line-height: 1;
    color: #aaa;
    &.is-error {
      color: #f56c6c;
    }
  }
}
</style>

<style lang="less">
.w-e-text-container {
  border-color: #1b2642 !important;
}

.w-e-toolbar {
  background-color: #1b2642 !important;
  border: none !important;
}
.w-e-toolbar .w-e-menu i {
  color: rgba(255, 255, 255, 0.7);
}
.w-e-toolbar .w-e-active i {
  color: #32e9ff;
}

.w-e-toolbar .w-e-menu:hover i {
  color: #1753a6;
}
</style>
